import { useState, useEffect } from "react";
import { Clock } from "lucide-react";

function getTarget() {
  const stored = localStorage.getItem("tut_offer_end");
  if (stored) {
    const parsed = new Date(stored).getTime();
    if (parsed > Date.now()) return parsed;
  }
  const target = Date.now() + 24 * 60 * 60 * 1000;
  localStorage.setItem("tut_offer_end", new Date(target).toISOString());
  return target;
}

export default function MiniTimer({ variant = "default" }) {
  const [target] = useState(getTarget);
  const [t, setT] = useState({ h: 0, m: 0, s: 0 });

  useEffect(() => {
    const tick = () => {
      const diff = Math.max(0, target - Date.now());
      setT({
        h: Math.floor(diff / 3600000),
        m: Math.floor((diff / 60000) % 60),
        s: Math.floor((diff / 1000) % 60),
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [target]);

  const pad = (n) => String(n).padStart(2, "0");
  const timeStr = `${pad(t.h)}:${pad(t.m)}:${pad(t.s)}`;

  if (variant === "dark") {
    return (
      <div data-testid="mini-timer" className="inline-flex items-center gap-1.5 bg-red-600/90 text-white text-[11px] font-bold px-3 py-1.5 rounded-full animate-pulse">
        <Clock className="w-3 h-3" />
        <span>FREE offer ଶେଷ: {timeStr}</span>
      </div>
    );
  }

  if (variant === "light") {
    return (
      <div data-testid="mini-timer" className="inline-flex items-center gap-1.5 bg-white/20 backdrop-blur-sm text-white text-[11px] font-bold px-3 py-1.5 rounded-full animate-pulse">
        <Clock className="w-3 h-3" />
        <span>Offer ଶେଷ ହେଉଛି: {timeStr}</span>
      </div>
    );
  }

  return (
    <div data-testid="mini-timer" className="inline-flex items-center gap-1.5 bg-red-50 border border-red-200 text-red-700 text-[11px] font-bold px-3 py-1.5 rounded-full">
      <Clock className="w-3 h-3 animate-pulse" />
      <span>ଏହି Offer ଶେଷ: <span className="tabular-nums">{timeStr}</span></span>
    </div>
  );
}
